import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiPhone, FiMail } = FiIcons;

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <motion.nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'glass-card' : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="text-2xl font-bold text-white">
            Kumarana Hotel
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-white hover:text-blue-300 transition-colors">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-white hover:text-blue-300 transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection('rooms')} className="text-white hover:text-blue-300 transition-colors">
              Rooms
            </button>
            <button onClick={() => scrollToSection('restaurant')} className="text-white hover:text-blue-300 transition-colors">
              Restaurant
            </button>
            <Link to="/lunch-stop" className="text-white hover:text-blue-300 transition-colors">
              Lunch Stop
            </Link>
            <button onClick={() => scrollToSection('heritage')} className="text-white hover:text-blue-300 transition-colors">
              Heritage
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-white hover:text-blue-300 transition-colors">
              Contact
            </button>
            <a href="tel:076-8727112" className="btn-glass">
              <SafeIcon icon={FiPhone} />
              Call Now
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white"
          >
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            className="md:hidden glass-card mt-4 p-4 rounded-lg"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('home')} className="text-white text-left">Home</button>
              <button onClick={() => scrollToSection('about')} className="text-white text-left">About</button>
              <button onClick={() => scrollToSection('rooms')} className="text-white text-left">Rooms</button>
              <button onClick={() => scrollToSection('restaurant')} className="text-white text-left">Restaurant</button>
              <Link to="/lunch-stop" className="text-white" onClick={() => setIsOpen(false)}>Lunch Stop</Link>
              <button onClick={() => scrollToSection('heritage')} className="text-white text-left">Heritage</button>
              <button onClick={() => scrollToSection('contact')} className="text-white text-left">Contact</button>
              <a href="tel:076-8727112" className="btn-glass w-fit">
                <SafeIcon icon={FiPhone} />
                076-8727112
              </a>
            </div>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
}

export default Navbar;